/* ml-home.js
   One job: click-to-play video facades in ml-home-split.

   The poster image and a play button stand in for the embed, and the
   iframe is only created once someone actually asks for it. Three video
   rows on a page therefore cost zero YouTube players on first load
   rather than three.

   Delegated from the document, so it survives theme-editor section
   re-renders without rebinding, and guarded so repeated section renders
   do not attach the handler more than once. */
(function () {
  if (window.mlHomeVideoReady) return;
  window.mlHomeVideoReady = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.mlx-play') : null;
    if (!btn) return;

    var src = btn.getAttribute('data-src');
    var media = btn.closest('.mlx-media');
    if (!src || !media) return;

    e.preventDefault();

    var frame = document.createElement('iframe');
    frame.src = src;
    frame.title = btn.getAttribute('data-title') || 'Video';
    frame.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('loading', 'lazy');

    media.innerHTML = '';
    media.appendChild(frame);
  });
})();

/* Hero slideshow.

   A crossfade over slides that are already in the DOM, so there is no
   layout work per tick and nothing shifts. Autoplay stops while a
   pointer is over the card, while focus is inside it, and while the tab
   is hidden, because a carousel that keeps moving under someone's
   cursor is the reason carousels have the reputation they have.

   prefers-reduced-motion switches autoplay off entirely. The dots still
   work, so the images are all still reachable, they just never move on
   their own. */
(function () {
  if (window.mlHeroSlidesReady) return;
  window.mlHeroSlidesReady = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(rail) {
    if (rail.getAttribute('data-ml-bound')) return;
    rail.setAttribute('data-ml-bound', '1');

    var slides = [].slice.call(rail.querySelectorAll('.mlx-slide'));
    if (slides.length < 2) return;

    var shot = rail.parentNode;
    var dots = [].slice.call(shot.querySelectorAll('.mlx-dot'));
    var ms = parseInt(rail.getAttribute('data-ms'), 10) || 5000;
    var auto = rail.getAttribute('data-auto') === 'true' && !reduce;
    var at = 0;
    var timer = null;

    function show(n) {
      at = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('on', k === at);
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('on', k === at);
        d.setAttribute('aria-selected', k === at ? 'true' : 'false');
        d.setAttribute('tabindex', k === at ? '0' : '-1');
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (auto && !timer) {
        timer = setInterval(function () {
          show(at + 1);
        }, ms);
      }
    }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () {
        stop();
        show(k);
        start();
      });
      d.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        stop();
        show(k + (e.key === 'ArrowRight' ? 1 : -1));
        if (dots[at]) dots[at].focus();
        start();
      });
    });

    shot.addEventListener('mouseenter', stop);
    shot.addEventListener('mouseleave', start);
    shot.addEventListener('focusin', stop);
    shot.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    show(0);
    start();
  }

  function scan() {
    [].slice.call(document.querySelectorAll('.mlx-slides')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* The theme editor replaces a section's markup wholesale on every
     setting change, so a fresh rail needs binding again. */
  document.addEventListener('shopify:section:load', scan);
})();
